import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { updateStep } from 'Src/actions';
import { STEP_7_INSTAGRAM_PROFILE } from 'Src/components/OnBoarding/types';
import SpinnerFull from 'Src/components/SpinnerFull';

const InstagramAuth = ({
  history,
  match,
  setStep,
  steps,
}) => {
  const { url = '/v1' } = match;

  useEffect(() => {
    if (steps && steps.length) {
      const step = steps.findIndex(s => s.name === STEP_7_INSTAGRAM_PROFILE);
      setStep(step);
      history.replace(url);
    }
  }, [steps]);

  return (
    <SpinnerFull />
  );
};

const mapDispatchToProps = (dispatch) => ({
  setStep: step => dispatch(updateStep(step)),
});

export default connect(null, mapDispatchToProps)(InstagramAuth);
